/**
 * Schema prop groups
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstObjectOptsGroup } from "@adapptio/lib-blueprint";
import { termsEditor } from "../terms";

export const propGroups: Record<string, ISchemaConstObjectOptsGroup> = {
	__primary__: {
		label: null,
		id: "__primary__"
	},

	common: {
		...termsEditor.schemas.propGroups.common,
		id: "common",
		order: 0,
		defaultExpanded: true
	},

	state: {
		...termsEditor.schemas.propGroups.state,
		id: "state",
		order: 20,
		defaultExpanded: true
	},

	type: {
		...termsEditor.schemas.propGroups.type,
		id: "type",
		order: 30,
		defaultExpanded: true
	},

	style: {
		...termsEditor.schemas.propGroups.style,
		id: "style",
		order: 40,
		defaultExpanded: true
	},

	validation: {
		...termsEditor.schemas.propGroups.validation,
		id: "validation",
		order: 50,
		defaultExpanded: true
	},

	link: {
		...termsEditor.schemas.propGroups.link,
		id: "link",
		order: 35
	},

	advanced: {
		...termsEditor.schemas.propGroups.advanced,
		id: "advanced",
		order: 60
	}
};
